module.exports = __webpack_public_path__ + "media/8.b6eddf9d.mp3";